import React from "react";
import SiteMeta from "./SiteMeta";
import { Helmet } from 'react-helmet';


const SEO = ({page}: any) => {
    
    const { title, siteUrl } = SiteMeta();

    let pageTitle = page.title;
    let ogImage = siteUrl+'/img/lemonade-farm-og.jpg';
    const url = siteUrl+page.slug;

    if (!page.type || page.type === 'page') pageTitle += " - " + title;

    return (
        <Helmet>
            <html lang={page.lang ? page.lang : "fi"} />
            <title>{pageTitle}</title>
            { page.description ? <meta name="description" content={ page.description } /> : "" }
            { page.keywords ? <meta name="keywords" content={page.keywords.join(', ')} /> : "" }
            {/* OpenGraph tags */}
            <meta property="og:url" content={url} />
            { page.type === 'article' || page.type === 'landing-page' ? <meta property="og:type" content="article" /> : ""}
            <meta property="og:title" content={title} />
            { page.description ? <meta property="og:description" content={ page.description } /> : "" }
            <meta property="og:image" content={ogImage} />
            {/* <meta property="fb:app_id" content={seo.social.fbAppID} /> */}
            {/* Twitter Card tags 
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content={seo.social.twitter} />
            <meta name="twitter:title" content={title} />
            { page.description ? <meta name="twitter:description" content={ page.description } /> : "" }
            <meta name="twitter:image" content={image} />*/}
        </Helmet>
    );
}

export default SEO;
